$(document).on("metaslug_sinhnhat1tuoi_header rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    window.addEventListener("message", function (event) {
        if (event.data === "initScaled") {
            $("body").find("video source[data-src]").each(function () {
                const src = $(this).attr("data-src");

                // console.log(src);
                // console.log($("body").attr("data-device-type"));

                if ($("body").attr("data-device-type")) {
                    let determinedDevice = $("body").attr("data-device-type");
                    // console.log(determinedDevice);
                    // console.log($(this).parent("video").hasClass(determinedDevice));
                    if ($(this).parent("video").hasClass(determinedDevice)) {
                        $(this).attr("src", src);
                        // play video
                        $(this).parent("video").get(0).load();
                    }
                }

            });
        }
    });

});